import React, { useRef, useState, useEffect } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { YhFormBox } from "@/components/YhFormBox";
import { ISelectOption } from "@/components/YhFormBox/Types";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import { useGoodsModel } from "../materialModel";
import { YhPageHeader } from "@/components/YhPageHeader";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IFormGoodsFields } from "../materialService";
import { getFormValidatorErrText } from "@/utils/utils"
import { useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel, { transOptions } from "../../../../model/globalModel";
import { warehouseService, IShelfFileds } from "../../warehouse/warehouseService"
import { itemService } from "../../item/itemService";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { debounce } from "lodash";
export const MaterialDetails = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, warehouseList } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { addFormVal, editFormVal, shelfAllList,setSelectedRowKeys, updateAddFormVal, setShelfAllList, updateEditFormVal, insertGoods, editGoods, getGoodsOne, setAddFormVal } = useGoodsModel();
    const { getTreeSelectOne, getSelectedDictOne } = useDictModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const formRef = useRef<IYhFormRef>();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);


    //编辑时， 没有缓在调用详情接口
    useEffect(() => {
        if (!Object.keys(editFormVal).length && detailsInfo.mode === "edit") {
            getGoodsOne(detailsInfo.id)
        }
    }, [detailsInfo]);

    useEffect(() => {
        return () => {
            let addNavExist = findNav("13-2-1");
            let editNavExist = findNav("13-2-2");
            !addNavExist && updateAddFormVal(null);
            !editNavExist && updateEditFormVal(null);
        }
    }, [selectedNavId])
    useEffect(() => {
        console.log(warehouseList)
    }, [])
    //关闭当前页
    const onClose = () => {
        replaceNav(selectedNavId, "13-2");
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            let data = {
                ...res,
            }
            if (detailsInfo.mode === "edit") {
                editGoods({ ...data, id: detailsInfo.id }).then(res => {
                    res && onClose()
                })
            } else {
                insertGoods(data).then(res => {
                    if(res){
                        setSelectedRowKeys([res])
                        onClose()
                    }
                    // res && onClose()
                })
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //实时保留缓存
    const onChange = (changedValues: { [key: string]: any }) => {
        detailsInfo.mode === "edit" ? updateEditFormVal(changedValues) : updateAddFormVal(changedValues);
    }

    const onSelectChanges = async (value: string, option: ISelectOption) => {
        let params = {
            pageSize: 1000,
            pageNum: 1,
            warehouseCode: value
        }
        const { retData } = await warehouseService.shelfPage(params)
        const { records, ...pg } = retData;
        const newRecords = records.map((item: IShelfFileds) => { return { ...item, name: item.code } })
        setShelfAllList(newRecords)
    }
    const baseFormItem: IYhFormItemsBox = {
        // title: "基础信息",
        title: Locale["Basic Info"],
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "商品编号",
                fieldLabel: Locale["Material Code"],
                fieldName: "code",
                disable: detailsInfo.mode === "edit",
                placeholder: "自动生成",
                // rules: [{ required: true, message: "请输入商品编号" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]

            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "商品名称",
                fieldLabel: Locale["Material Name"],
                fieldName: "name",
                // rules: [{ required: true, message: "请输入商品名称" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "商品名称",
                fieldLabel: Locale["Material Name En"],
                fieldName: "nameEn",
                // rules: [{ required: true, message: "请输入商品名称" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "替换编号",
                fieldLabel: Locale["Replace Code"],
                fieldName: "replaceCode",
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "配件品牌",
                fieldLabel: Locale["Accessories brand"],
                fieldName: "brandCode",
                options: getSelectedDictOne(DictCodeEnmu.MATERIAL_BRAND),
                // rules: [{ required: true, message: "请选择配件品牌" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "计量单位",
                fieldLabel: Locale["Unit"],
                fieldName: "unitCode",
                options: getSelectedDictOne(DictCodeEnmu.MATERIAL_UNIT),
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "规格型号",
                fieldLabel: Locale["Spec&Model"],
                fieldName: "model",
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "商品分类",
                fieldLabel: Locale["Material Type"],
                fieldName: "typeCode",
                options: getSelectedDictOne(DictCodeEnmu.MATERIAL_TYPE),
                // rules: [{ required: true, message: "请选择商品分类" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note"
            }, {
                type: FormItemTypeEnum.Switch,
                // fieldLabel: "商品状态",
                fieldLabel: Locale["Status"],
                fieldName: "enable"
            }
        ]
    };
    const stockFormItem: IYhFormItemsBox = {
        // title: "库存信息",
        title: Locale["Inventory information"],
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [{
            type: FormItemTypeEnum.Select,
            // fieldLabel: "所属仓库",
            fieldLabel: Locale["Warehouse"],
            fieldName: "warehouseCode",
            onSelectChange: onSelectChanges,
            options: transOptions(warehouseList),
        }, {
            type: FormItemTypeEnum.Select,
            // fieldLabel: "所属货位",
            fieldLabel: Locale["Shelf"],
            fieldName: "shelfCode",
            allowClear: true,
            showSearch: true,
            options: transOptions(shelfAllList),
        }, {
            type: FormItemTypeEnum.Input,
            // fieldLabel: "库存上限",
            fieldLabel: Locale["Upper Limit"],
            fieldName: "limitUpper"
        }, {
            type: FormItemTypeEnum.Input,
            // fieldLabel: "库存下限",
            fieldLabel: Locale["Lower Limit"],
            fieldName: "limitLower"
        },]
    }
    const priceFormItem: IYhFormItemsBox = {
        // title: "商品价格",
        title: Locale["Material Price"],
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "进货价",
                fieldLabel: Locale["Purchase Price"],
                fieldName: "purchasePrice",
                rules: [{ required: true, message: "请输入进货价" }, { pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/, message: '请输入数值类型,可保留二位位小数' }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "零售价",
                fieldLabel: Locale["Retail Price"],
                fieldName: "retailPrice",
                rules: [{ required: true, message: "请输入进货价" }, { pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/, message: '请输入数值类型,可保留二位位小数' }]
            },
        ]
    }

    const otherFormItem: IYhFormItemsBox = {
        // title: "其它信息",
        title: Locale["Material Price"],
        // disabled: true,
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "创建人",
                fieldLabel: Locale["Founder"],
                disable: true,
                fieldName: "createUser"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "创建时间",
                fieldLabel: Locale["Founder Time"],
                disable: true,
                fieldName: "createTime"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "修改人",
                fieldLabel: Locale["Updater"],
                disable: true,
                fieldName: "updateUser"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "修改时间",
                fieldLabel: Locale["Update Time"],
                disable: true,
                fieldName: "updateTime"
            }
        ]
    }

    const supplierFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: detailsInfo.mode === "edit" ? { ...editFormVal } : { ...addFormVal },
        onChange,
        boxs: [baseFormItem, stockFormItem, priceFormItem, otherFormItem]
    }

    const reset = async () => {
        formRef.current?.resetFields()
        if (detailsInfo.mode === "add") {
            setAddFormVal({ limitUpper: 0, limitLower: 0 })
        } else if (detailsInfo.mode === "edit") {
            getGoodsOne(detailsInfo.id)
        }
        message.success("重置成功")
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            // onClick={onSubmit}
            onClick={debounce(() => { onSubmit() }, 900)}
        >{Locale["Save"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { reset() }}
        >{Locale["Reset"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onClose}
        >{Locale["Back"]}</Button>
    </>;

    return (
        <>
            <YhPageHeader title={Locale["Material Details"]} />
            <YhBox title={`${detailsInfo.mode === "edit" ? Locale["Edit"] : Locale["Add"]}    ${Locale["Material Management"]}`} action={action} style={{ paddingBottom: "0px", marginBottom: "15px" }}></YhBox>
            <YhFormBox {...supplierFromConfig} />
        </>
    )
}